<template>
  <div class="container-table-auth">
    <q-card>
      <q-card-section>
        <div class="row col-12 filter-card-container">
          <div class="title">Filtros</div>
        </div>
        <div class="row col-12" style="display: flex">
          <div class="col-2 col-sm-12 col-md-3 col-lg-3 item-select">
            <q-select
              data-cy="app-list"
              outlined
              v-model="appSelected"
              :options="listApps"
              option-value="id"
              option-label="name"
              label="Aplicación"
              clearable
              :disable="isDeliveryUser && !isSuperAdmin"
            />
          </div>
          <div class="col-2 col-sm-12 col-md-3 col-lg-3 item-select">
            <q-select
              data-cy="entidad-list"
              outlined
              v-model="entidadSelected"
              :options="listEntidades"
              option-value="id"
              option-label="name"
              label="Entidad"
              clearable
            />
          </div>
          <div class="col-2 col-sm-12 col-md-3 col-lg-3 item-select">
            <q-select
              data-cy="status-list"
              outlined
              v-model="statusSelected"
              :options="listStatus"
              option-value="value"
              option-label="label"
              label="Estado"
              clearable
            />
          </div>
          <div class="col-6 col-sm-12 col-md-3 col-lg-3 item-button">
            <q-btn
              data-cy="filter-btn"
              color="primary"
              label="Filtrar"
              @click="filterList()"
            />
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Message from '@/components/shared/mixins/Message.js';
import Loading from '@/components/shared/mixins/Loading.js';

import { QCard, QCardSection } from 'quasar';
import { StatusModel } from './status.model';

export default {
  components: {
    QCard,
    QCardSection
  },
  mixins: [Message, Loading],
  props: {
    authorizations: Array
  },
  computed: {
    ...mapGetters({
      userId: 'PF/userId',
      isDeliveryUser: 'PF/isDeliveryUser',
      isSuperAdmin: 'PF/isSuperAdmin'
    })
  },
  data () {
    return {
      data: this.authorizations,
      selectedApp: [],
      listApps: [],
      appSelected: null,
      listEntidades: [],
      entidadSelected: null,
      listStatus: StatusModel.model,
      statusSelected: StatusModel.model[0]
    };
  },
  mounted () {
    this.getData();
    this.filterList();
  },
  methods: {
    getData () {
      if (!this.isDeliveryUser || this.isSuperAdmin) { this.getListApp(); };
      this.getListEntidad();
    },
    getListApp () {
      const request = {
        controller: '/Aplicacion/all'
      };

      this.$store
        .dispatch('PF/getSuit', request)
        .then((response) => {
          this.listApps = response.data;
          this.hideLoading();
        })
        .catch((err) => {
          this.showError(err.message);
          this.hideLoading();
        });
    },
    getListEntidad () {
      const request = {
        controller: this.isDeliveryUser || this.isSuperAdmin ? `/Entidad/DeliveryUser` : `/Entidad/User/${this.userId}`
      };

      this.$store
        .dispatch('PF/getSuit', request)
        .then((response) => {
          this.listEntidades = response.data.filter((el) => el.visible);
          this.hideLoading();
        })
        .catch((err) => {
          this.showError(err.message);
          this.hideLoading();
        });
    },
    filterList () {
      const filterElement = {
        status: this.statusSelected?.value ?? '',
        entityId: this.entidadSelected?.id ?? '',
        applicationId: this.appSelected?.id ?? ''
      };

      this.$emit('filterList', filterElement);
    }
  },
  watch: {
    authorizations: {
      handler: function () {
        this.data = this.authorizations;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-table-auth {
  .filter-card-container {
    margin-bottom: 10px;
  }

  .item-select {
    padding-right: 20px;
  }

  .item-button {
    margin-top: auto;
    display: flex;
    justify-content: flex-end;
  }

  &:deep() {
    .q-table__card {
      box-shadow: none;
    }

    .q-card__section--vert {
      padding: 0 !important;
    }
  }
}
</style>
